import {
    CREATE_GENERAL_PO_INWARD_MASTER_REQUEST,
    CREATE_GENERAL_PO_INWARD_MASTER_SUCCESS,
    CREATE_GENERAL_PO_INWARD_MASTER_FAILURE,
    DELETE_GENERAL_PO_INWARD_MASTER_REQUEST,
    DELETE_GENERAL_PO_INWARD_MASTER_SUCCESS,
    DELETE_GENERAL_PO_INWARD_MASTER_FAILURE,
    FETCH_SINGLE_GENERAL_PO_INWARD_MASTER_REQUEST,
    FETCH_SINGLE_GENERAL_PO_INWARD_MASTER_SUCCESS,
    FETCH_SINGLE_GENERAL_PO_INWARD_MASTER_FAILURE,
    FETCH_GENERAL_PO_INWARD_MASTER_REQUEST,
    FETCH_GENERAL_PO_INWARD_MASTER_SUCCESS,
    FETCH_GENERAL_PO_INWARD_MASTER_FAILURE,
    UPDATE_GENERAL_PO_INWARD_MASTER_REQUEST,
    UPDATE_GENERAL_PO_INWARD_MASTER_SUCCESS,
    UPDATE_GENERAL_PO_INWARD_MASTER_FAILURE,
    RESET_GENERAL_PO_INWARD_MASTER_INFO,
    CREATE_GENERAL_PO_INWARD_MASTER_FORM,
    UPDATE_GENERAL_PO_INWARD_MASTER_FORM,
    NAVIGATE_GENERAL_PO_INWARD_DETAILS,
    NAVIGATE_GENERAL_PO_INWARD_MASTER,
    SET_PENDING_GRID_NAME_GENERAL_PO_INWARD,
    FETCH_PENDING_GENERAL_PO_IN_INWARD_REQUEST,
    FETCH_PENDING_GENERAL_PO_IN_INWARD_FAILURE,
    FETCH_PENDING_GENERAL_PO_IN_INWARD_SUCCESS,
    SET_UNIT_NAME_GENERAL_PO_INWARD,
    SET_ACTIVE_KEY_GENERAL_PO_INWARD_MASTER,
    GENERAL_PO_INWARD_USERFORM_RESET,
    NAVIGATE_TO_DETAIL_TAB,
    SET_END_DATE_GENERAL_PO_INWARD,
    SET_START_DATE_GENERAL_PO_INWARD
} from './generalPoInwardHeader.actionsType';

export const GENERAL_PO_INWARD_MASTER = 'generalPoInwardHeader';

let initialState = {
    loading: false,
    pendingGeneralPO: [],
    generalPoInwardHeader: [],
    generalPoInwardHeaderId: '',
    generalPoInwardHeaderForm: {},
    selectedState: {},
    errorMessage: '',
    singleGeneralPoInwardData: null,
    isIroningGeneralPoInwardDetails: false,
    renderGridBtn: 'pendingGrid',
    unitId: 1,
    startDate: new Date().setDate(new Date().getDate() - 15),
    endDate: new Date(),
    activeKey: 1
};

export let generalPoInwardHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_GENERAL_PO_INWARD_MASTER_REQUEST:
        case CREATE_GENERAL_PO_INWARD_MASTER_REQUEST:
        case UPDATE_GENERAL_PO_INWARD_MASTER_REQUEST:
        case FETCH_SINGLE_GENERAL_PO_INWARD_MASTER_REQUEST:
        case DELETE_GENERAL_PO_INWARD_MASTER_REQUEST:
        case FETCH_PENDING_GENERAL_PO_IN_INWARD_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_GENERAL_PO_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoInwardHeader: updatePayload
            };

        case FETCH_PENDING_GENERAL_PO_IN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingGeneralPO: updatePayload
            };
        case CREATE_GENERAL_PO_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                },
                generalPoInwardHeaderId: updatePayload,
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case UPDATE_GENERAL_PO_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                },

            };
        case FETCH_SINGLE_GENERAL_PO_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoInwardHeaderForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case DELETE_GENERAL_PO_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                }
            };
        case RESET_GENERAL_PO_INWARD_MASTER_INFO:
            return {
                ...state,
                generalPoInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                }
            };
        case CREATE_GENERAL_PO_INWARD_MASTER_FORM:
        case UPDATE_GENERAL_PO_INWARD_MASTER_FORM:
            return {
                ...state,
                loading: false,
                generalPoInwardHeaderForm: {
                    ...state.generalPoInwardHeaderForm,
                    [payload.key]: payload.value
                }
            };
        case GENERAL_PO_INWARD_USERFORM_RESET:
            return {
                ...state,
                generalPoInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                },
                generalPoInwardHeaderId: '',
                selectedState: {},
                activeKey: 1
            };
        case FETCH_GENERAL_PO_INWARD_MASTER_FAILURE:
        case CREATE_GENERAL_PO_INWARD_MASTER_FAILURE:
        case UPDATE_GENERAL_PO_INWARD_MASTER_FAILURE:
        case FETCH_SINGLE_GENERAL_PO_INWARD_MASTER_FAILURE:
        case DELETE_GENERAL_PO_INWARD_MASTER_FAILURE:
        case FETCH_PENDING_GENERAL_PO_IN_INWARD_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_GENERAL_PO_INWARD_DETAILS:
            return {
                ...state,
                isIroningGeneralPoInwardDetails: true,
                singleGeneralPoInwardData: updatePayload.singleGeneralPoInwardData
                // generalPoInwardHeaderSelectedValue: updatePayload.generalPoInwardHeaderSelectedValue
            };
        case NAVIGATE_GENERAL_PO_INWARD_MASTER:
            return {
                ...state,
                isIroningGeneralPoInwardDetails: false
            };
        case SET_PENDING_GRID_NAME_GENERAL_PO_INWARD:
            return {
                ...state,
                renderGridBtn: payload
            };
        case SET_UNIT_NAME_GENERAL_PO_INWARD:
            return {
                ...state,
                unitId: payload
            };
        case SET_START_DATE_GENERAL_PO_INWARD:
            return {
                ...state,
                startDate: payload
            };
        case SET_END_DATE_GENERAL_PO_INWARD:
            return {
                ...state,
                endDate: payload
            };
        case SET_ACTIVE_KEY_GENERAL_PO_INWARD_MASTER:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                loading: false,
                activeKey: 2
            }
        default:
            return state;
    }
};
